<template>
  <div class="text-center">
    <div>
      <v-icon size="80" color="green" class="my-3">mdi-file-check</v-icon>
      <p class="ma-0 font-weight-medium" v-html="'Pedido exportado com sucesso para o Protheus.'" />
    </div>

    <div class="mx-16 mt-4 border-gray-500 bra-10 py-2" style="background: #f9f9f9;">
      <p class="ma-0 font-14 font-weight-medium mt-4px">ID Pedido Protheus</p>
      <p class="ma-0 font-14 mt-n1 text-uppercase">{{ resultado_exportacao.idpedido_protheus }}</p>
    </div>
  </div>
</template>

<script setup>
import {ref, onMounted, computed} from "vue";
import api from "@/api/api.js";
import { logout } from "@/helpers";

const props = defineProps({
  idpedido_systock: Number,
});

const resultado_exportacao = ref({
  idpedido_protheus: '',
});

onMounted(buscarResultadoExportacao);

function buscarResultadoExportacao() {
  api.get(`pedidos-drp/${props.idpedido_systock}/exportacao/casa-tudo-sacolao/resultado-exportacao`)
    .then(resposta => {
      resultado_exportacao.value = resposta.data.resultado_exportacao;
    })
    .catch(logout);
}
</script>
